import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Budget, BudgetCreate, BudgetFilter } from '../data/budget';

export function createBudgetService(client: AxiosInstance) {
  return createCrudService<Budget, BudgetCreate, BudgetFilter>(
    client,
    '/accounting/Budget',
    'id',
  );
}

export type BudgetService = CrudService<Budget, BudgetCreate, BudgetFilter>;
